export default __webpack_public_path__ + "3bf6360dba57d181bf3bc94dd783b1f3.svg";